import { Injectable, signal } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { DashboardBulkSelection, searchFingerprint } from '../types/dashboard-bulk-selection';

@Injectable()
export class DashboardBulkSelectionService {
  private readonly state = signal<DashboardBulkSelection>(Object.freeze({ mode: 'none' }));
  readonly selection = this.state.asReadonly();

  clear(): void { this.state.set(Object.freeze({ mode: 'none' })); }

  selectIds(ids: number[], searchParams: HttpParams): void {
    if (!ids.length) { this.clear(); return; }
    this.state.set(Object.freeze({ mode: 'ids', ids: Object.freeze([...new Set(ids)]), searchParams }));
  }

  selectQuery(count: number, searchParams: HttpParams): void {
    if (!Number.isSafeInteger(count) || count < 1) return;
    this.state.set(Object.freeze({ mode: 'query', count, searchParams: searchParams.delete('pageNumber') }));
  }

  retainForSearch(params: HttpParams): boolean {
    const selected = this.state();
    if (selected.mode === 'query' && searchFingerprint(selected.searchParams) === searchFingerprint(params)) return true;
    this.clear();
    return false;
  }

  updateQueryPage(rows: readonly { id: number; checked: boolean }[], offset: number): void {
    const selected = this.state();
    if (selected.mode !== 'query') return;
    const excluded = new Set(selected.excludedIds || []);
    const added = new Set(selected.addedIds || []);
    rows.forEach((row, index) => {
      if (offset + index < selected.count) {
        row.checked ? excluded.delete(row.id) : excluded.add(row.id);
        added.delete(row.id);
      } else {
        row.checked ? added.add(row.id) : added.delete(row.id);
      }
    });
    this.state.set(Object.freeze({ ...selected,
      excludedIds: Object.freeze([...excluded]), addedIds: Object.freeze([...added]) }));
  }
}
